<template>
  <div>
    <!-- locations are not supported for first iteration -->
  </div>
</template>

<script>
export default {
  name: 'EventCreationModalLocations',
  props: {
    locations: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    localLocations: [],
  }),

  emits: ['update-locations'],

  methods: {
    update() {
      this.$emit('update-locations', this.localLocations)
      this.$router.go(-1)
    },
  },

  watch: {
    locations: {
      handler: function (locations) {
        this.localLocations = this.$clone(locations)
      },

      immediate: true,
      deep: true,
    },
  },
}
</script>
